import { Box, Container, Flex, Text, VStack } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import usePathNavigate from "../lib/hook/usePathNavigate";
import { useEffect, useState } from "react";
import { CheckIcon } from "@chakra-ui/icons";
import { setOemPayment } from "./api";
import { ResStatus } from "../lib/api/enum";

const PaymentsCompleted = () => {
    const location = useLocation();
    const { pathNavigate, backNavigate } = usePathNavigate();
    const [loaded, setLoaded] = useState(false);

    const searchParams = new URLSearchParams(location.search);
    const {
        web,
        imp_uid,
        merchant_uid,
        error_code,
        error_msg,
        delivery_method,
        reservation_date,
        order_id,
        imp_success,
    } = {
        web: searchParams.get("web"),
        imp_uid: searchParams.get("imp_uid"),
        merchant_uid: searchParams.get("merchant_uid"),
        error_code: searchParams.get("error_code"),
        error_msg: searchParams.get("error_msg"),
        delivery_method: searchParams.get("delivery_method"),
        reservation_date: searchParams.get("reservation_date"),
        order_id: searchParams.get("order_id"),
        imp_success: searchParams.get("imp_success"),
    };

    const setPayment = async () => {
        try {
            const result = await setOemPayment({
                merchant_uid: merchant_uid!,
                imp_uid: imp_uid!,
            });
            console.log("setPayment : ", result);

            if (result.status === ResStatus.RES_SUCCESS) {
                setLoaded(true);
                localStorage.removeItem("paymentToken");
                // const token = localStorage.getItem("paymentToken");
                // pathNavigate(`/oemrequestpay?t=${token}`);
            } else {
                alert(result.result_message);

                const token = localStorage.getItem("paymentToken");
                pathNavigate(`/oemrequestpay?t=${token}`);
            }
        } catch (err: any) {
            alert(err);
            const token = localStorage.getItem("paymentToken");
            pathNavigate(`/oemrequestpay?t=${token}`);
        }
    };

    useEffect(() => {
        // imp_uid, merchant_uid, error_code, error_msg
        console.log(
            "searchParams : ",
            imp_uid,
            merchant_uid,
            imp_success,
            error_code,
            error_msg,
            web,
            delivery_method,
            reservation_date,
            order_id
        );

        if (web != null) {
            // pc 환경
            if (error_code != "undefined") {
                alert(error_msg);

                const token = localStorage.getItem("paymentToken");
                pathNavigate(`/oemrequestpay?t=${token}`);
            } else setPayment();
        } else {
            // 모바일 환경
            if (imp_success == "true") setPayment();
            else {
                alert(error_msg);

                const token = localStorage.getItem("paymentToken");
                pathNavigate(`/oemrequestpay?t=${token}`);
            }
        }
    }, []);

    return (
        <Container
            maxW={"768px"}
            minW={"320px"}
            w={"100%"}
            height={"100vh"}
            px={0}
            bg={"white"}
        >
            <Box w={"100%"} h={"100%"}>
                {loaded && (
                    <VStack w={"100%"} h={"100%"} justifyContent={"center"}>
                        <Flex
                            w={"54px"}
                            h={"54px"}
                            borderRadius={"full"}
                            border={"3px solid black"}
                            justifyContent={"center"}
                            alignItems={"center"}
                            mb={"10px"}
                        >
                            <CheckIcon boxSize={"18px"} />
                        </Flex>
                        <Text fontSize="22px" fontWeight={"semibold"}>
                            결제가 완료되었습니다.
                        </Text>
                        <Text fontSize="14px" color={"#757575"}>
                            확인 후 요청하신 서비스가 진행될 예정입니다.
                        </Text>
                    </VStack>
                )}
            </Box>
        </Container>
    );
};

export default PaymentsCompleted;
